import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _asyncToGenerator from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _sample from "lodash/sample";
import _isArray from "lodash/isArray";
import _mergeWith from "lodash/mergeWith";
import _cloneDeep from "lodash/cloneDeep";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es6.array.find.js";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es7.object.values.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es7.object.entries.js";
import dayjs from 'dayjs';
import { SAMPLES_CREATED, SAMPLES_ERROR, SAMPLES_SAVED, SAMPLES_SAVING } from 'redux/actionTypes/samples';
import fetchAPI from 'utils/http/fetchAPI';
import handleError from 'utils/http/handleError';
import endUserMessages from 'utils/endUserMessages';
import { METADATA_DEFAULT_VALUE } from 'redux/reducers/experiments/initialState';
import { defaultSampleOptions, sampleTemplate } from 'redux/reducers/samples/initialState';
import { sampleTech } from 'utils/constants';
import UploadStatus from 'utils/upload/UploadStatus';
import { createMetadataTrack, updateValuesInMetadataTrack } from '../experiments';
var metadataValuesByTechnology = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, sampleTech.PARSE, 'Parse Evercode WT'), sampleTech['10X'], '10X Chromium'), sampleTech.RHAPSODY, 'BD Rhapsody'), sampleTech.SEURAT, 'Seurat'), sampleTech.H5, '10X Chromium - H5');

// If the sample name of new samples coincides with already existing
// ones we should not create new samples,
// just reuse their sampleIds and upload the new files
var splitByAlreadyExistingSamples = function splitByAlreadyExistingSamples(newSamples, sampleIds, samples, sampleTechnology, options, kit) {
  var alreadyCreatedSampleIds = {};
  sampleIds.forEach(function (sampleId) {
    var _newSamples$find;
    var _ref = (_newSamples$find = newSamples.find(function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 1),
          name = _ref4[0];
        return name === samples[sampleId].name;
      })) !== null && _newSamples$find !== void 0 ? _newSamples$find : [],
      _ref2 = _slicedToArray(_ref, 1),
      _ref2$ = _ref2[0],
      repeatedSampleName = _ref2$ === void 0 ? null : _ref2$;
    if (!repeatedSampleName) return;
    alreadyCreatedSampleIds[repeatedSampleName] = sampleId;
  });
  var samplesToCreate = newSamples
  // Upload only the samples that don't have a repeated name
  .filter(function (_ref5) {
    var _ref6 = _slicedToArray(_ref5, 1),
      name = _ref6[0];
    return !alreadyCreatedSampleIds[name];
  }).map(function (_ref7) {
    var _ref8 = _slicedToArray(_ref7, 1),
      name = _ref8[0];
    return {
      name: name,
      sampleTechnology: sampleTechnology,
      options: options,
      kit: kit
    };
  });
  return {
    samplesToCreate: samplesToCreate,
    alreadyCreatedSampleIds: alreadyCreatedSampleIds
  };
};
var getSamplesByTechnology = function getSamplesByTechnology(samples) {
  return samples.reduce(function (acc, sample) {
    var _acc$sample$type;
    acc[sample.type] = (_acc$sample$type = acc[sample.type]) !== null && _acc$sample$type !== void 0 ? _acc$sample$type : [];
    acc[sample.type].push(sample);
    return acc;
  }, {});
};
var createSamples = function createSamples(experimentId, newSamples, sampleTechnology) {
  return /*#__PURE__*/function () {
    var _ref9 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch, getState) {
      var _oldSamplesByTechnolo;
      var experiment, _getState, samples, createdDate, options, kit, oldSamples, oldSamplesByTechnology, _firstSample, _splitByAlreadyExisti, samplesToCreate, alreadyCreatedSampleIds, url, _sample2, _Object$values$, _newSampleIdsByName, _sampleIdsByName, _newSamplesToRedux, _newSamplesToUpdateByTechnology, _allSamples, _technologyMetadataTrackExists, _samplesToUpdateByTechnology, _updates, _errorMessage;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              dispatch({
                type: SAMPLES_SAVING,
                payload: {
                  message: endUserMessages.SAVING_SAMPLE
                }
              });
              experiment = getState().experiments[experimentId];
              _getState = getState(), samples = _getState.samples;
              createdDate = dayjs().toISOString();
              if (Object.values(sampleTech).includes(sampleTechnology)) {
                _context.next = 6;
                break;
              }
              throw new Error("Sample technology ".concat(sampleTechnology, " is not recognized"));
            case 6:
              options = defaultSampleOptions[sampleTechnology] || {};
              kit = null;
              oldSamples = experiment.sampleIds.map(function (sampleId) {
                return samples[sampleId];
              });
              oldSamplesByTechnology = getSamplesByTechnology(oldSamples); // If there are other parse samples in the same experiment, use the options and kit
              // values from the other ones (since we don't allow multi kits exps yet)
              if (sampleTechnology === 'parse' && ((_oldSamplesByTechnolo = oldSamplesByTechnology.parse) === null || _oldSamplesByTechnolo === void 0 ? void 0 : _oldSamplesByTechnolo.length) > 0) {
                _firstSample = oldSamplesByTechnology.parse[0];
                options = _firstSample.options;
                kit = _firstSample.kit;
              }
              _splitByAlreadyExisti = splitByAlreadyExistingSamples(newSamples, experiment.sampleIds, samples, sampleTechnology, options, kit), samplesToCreate = _splitByAlreadyExisti.samplesToCreate, alreadyCreatedSampleIds = _splitByAlreadyExisti.alreadyCreatedSampleIds;
              if (!(samplesToCreate.length === 0)) {
                _context.next = 15;
                break;
              }
              dispatch({
                type: SAMPLES_SAVED
              });
              return _context.abrupt("return", alreadyCreatedSampleIds);
            case 15:
              url = "/v2/experiments/".concat(experimentId, "/samples");
              _context.prev = 16;
              _context.next = 19;
              return fetchAPI(url, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(samplesToCreate)
              });
            case 19:
              _newSampleIdsByName = _context.sent;
              // Join the already existing sampleIds with the new ones,
              // order is preserved in newSamples
              _sampleIdsByName = _objectSpread(_objectSpread({}, alreadyCreatedSampleIds), _newSampleIdsByName);
              _newSamplesToRedux = newSamples
              // Remove repeated samples
              .filter(function (_ref0) {
                var _ref1 = _slicedToArray(_ref0, 1),
                  name = _ref1[0];
                return _newSampleIdsByName[name];
              }).map(function (_ref10) {
                var _experiment$metadataK;
                var _ref11 = _slicedToArray(_ref10, 2),
                  name = _ref11[0],
                  files = _ref11[1].files;
                return _objectSpread(_objectSpread({}, _cloneDeep(sampleTemplate)), {}, {
                  name: name,
                  type: sampleTechnology,
                  experimentId: experimentId,
                  uuid: _sampleIdsByName[name],
                  createdDate: createdDate,
                  lastModified: createdDate,
                  options: options,
                  metadata: (_experiment$metadataK = experiment === null || experiment === void 0 ? void 0 : experiment.metadataKeys.reduce(function (acc, metadataKey) {
                    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, metadataKey, METADATA_DEFAULT_VALUE));
                  }, {})) !== null && _experiment$metadataK !== void 0 ? _experiment$metadataK : {},
                  files: Object.keys(files).reduce(function (acc, fileType) {
                    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, fileType, {
                      upload: {
                        status: UploadStatus.UPLOADING
                      }
                    }));
                  }, {})
                });
              });
              dispatch({
                type: SAMPLES_CREATED,
                payload: {
                  experimentId: experimentId,
                  samples: _newSamplesToRedux
                }
              });
              _newSamplesToUpdateByTechnology = getSamplesByTechnology(_newSamplesToRedux);
              _allSamples = _mergeWith({}, _newSamplesToUpdateByTechnology, oldSamplesByTechnology, function (objValue, srcValue) {
                if (_isArray(objValue) && _isArray(srcValue)) {
                  return objValue.concat(srcValue);
                }
              });
              _technologyMetadataTrackExists = Boolean((_sample2 = _sample((_Object$values$ = Object.values(oldSamplesByTechnology)[0]) !== null && _Object$values$ !== void 0 ? _Object$values$ : [])) === null || _sample2 === void 0 || (_sample2 = _sample2.metadata) === null || _sample2 === void 0 ? void 0 : _sample2.Technology);
              _samplesToUpdateByTechnology = _newSamplesToUpdateByTechnology; // If multitech, then add the Technology metadata track
              if (!(Object.keys(_allSamples).length > 1 && !_technologyMetadataTrackExists)) {
                _context.next = 32;
                break;
              }
              _context.next = 30;
              return dispatch(createMetadataTrack('Technology', experimentId));
            case 30:
              _samplesToUpdateByTechnology = _allSamples;
              _technologyMetadataTrackExists = true;
            case 32:
              if (!_technologyMetadataTrackExists) {
                _context.next = 36;
                break;
              }
              _updates = Object.entries(_samplesToUpdateByTechnology).map(function (_ref12) {
                var _ref13 = _slicedToArray(_ref12, 2),
                  technology = _ref13[0],
                  currSamples = _ref13[1];
                return {
                  value: metadataValuesByTechnology[technology],
                  sampleIds: currSamples.map(function (sample) {
                    return sample.uuid;
                  })
                };
              });
              _context.next = 36;
              return dispatch(updateValuesInMetadataTrack(experimentId, 'Technology', _updates));
            case 36:
              dispatch({
                type: SAMPLES_SAVED
              });
              return _context.abrupt("return", _sampleIdsByName);
            case 40:
              _context.prev = 40;
              _context.t0 = _context["catch"](16);
              console.error(_context.t0);
              _errorMessage = handleError(_context.t0, endUserMessages.ERROR_CREATING_SAMPLE);
              dispatch({
                type: SAMPLES_ERROR,
                payload: {
                  error: _errorMessage
                }
              });

              // throw again the error so `processSampleUpload` won't upload the sample
              throw new Error(_errorMessage);
            case 46:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[16, 40]]);
    }));
    return function (_x, _x2) {
      return _ref9.apply(this, arguments);
    };
  }();
};
export default createSamples;